import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class StatusService {
    public showingChangeArea: Subject<boolean> = new Subject();
}